import _isEmpty from 'lodash/isEmpty';

import {
  VIEW_TEMPLATE_MODE,
  EDIT_TEMPLATE_MODE,
  APPLY_TEMPLATE_MODE,
  CREATE_TEMPLATE_MODE,
} from 'components/modules/theme-templates/constants';

import {
  NAME_REQUIRED_ERROR,
  STYLE_RULES_REQUIRED_ERROR,
  STYLE_RULE_NAME_AND_VALUE_REQUIRED_ERROR,
  TYPE_REQUIRED_ERROR,
  STYLE_RULE_NAMES_MUST_BE_UNIQUE_ERROR,
} from './ThemeTemplateModal.constants';

export function getModeCtaCallback(mode, { onEditTemplate, onApplyTemplate, onClose }) {
  const modeCtaMap = {
    [VIEW_TEMPLATE_MODE]: onClose,
    [EDIT_TEMPLATE_MODE]: onEditTemplate,
    [CREATE_TEMPLATE_MODE]: onEditTemplate,
    [APPLY_TEMPLATE_MODE]: onApplyTemplate,
  };

  return modeCtaMap[mode];
}

export function createTemplateTagOptions(tags) {
  return tags.map((tag) => ({ key: tag, text: tag, value: tag }));
}

export function createOverrideOptions(styleRules) {
  return styleRules.reduce((acc, { name }) => ({ ...acc, [name]: true }), {});
}

export function isStyleRuleEmpty(styleRule) {
  const { name, value } = styleRule || {};

  return _isEmpty(name) || _isEmpty(value);
}

export function areAllStyleRulesUnique(styleRules) {
  if (_isEmpty(styleRules)) {
    return true;
  }

  const styleRuleNames = styleRules.map(({ name }) => name);

  return new Set(styleRuleNames).size === styleRuleNames.length;
}

export function getInvalidStyleRulesErrors(styleRules) {
  const errors = [];

  styleRules.forEach(({ name }) => {
    if (name && !/^[a-zA-Z]+$/.test(name)) {
      errors.push(`Style rule name ${name} should only contain letters (a-z, A-Z)`);
    }
  });

  return errors;
}

export function validateTemplate(template) {
  const { name, styleRules = [], type } = template || {};
  let errors = [];

  if (_isEmpty(name)) {
    errors = [...errors, NAME_REQUIRED_ERROR];
  }

  if (_isEmpty(type)) {
    errors = [...errors, TYPE_REQUIRED_ERROR];
  }

  if (_isEmpty(styleRules)) {
    errors = [...errors, STYLE_RULES_REQUIRED_ERROR];
  }

  if (styleRules.some(isStyleRuleEmpty)) {
    errors = [...errors, STYLE_RULE_NAME_AND_VALUE_REQUIRED_ERROR];
  }

  if (!areAllStyleRulesUnique(styleRules)) {
    errors = [...errors, STYLE_RULE_NAMES_MUST_BE_UNIQUE_ERROR];
  }

  errors = [...errors, ...getInvalidStyleRulesErrors(styleRules)];

  return errors;
}
